import { CheckIcon, CopyIcon } from "@phosphor-icons/react";
import { useWorkflowClipboard } from "./react.tsx";

// Adapted from workers-sdk's local-explorer-ui workflows CopyButton: an
// always-visible icon button, unlike CopyButton.tsx which reveals on
// group/cell hover.
export function IconCopyButton({
  text,
  label = "Copy"
}: {
  text: string;
  label?: string;
}) {
  const { ready, copied, copy: handleCopy } = useWorkflowClipboard(text, 2000);

  return (
    <button
      type="button"
      className="inline-flex size-7 cursor-pointer items-center justify-center rounded-md text-kumo-subtle transition-colors hover:bg-kumo-fill"
      onClick={handleCopy}
      disabled={!ready}
      aria-busy={!ready}
      aria-label={label}
      title={label}
    >
      {copied ? (
        <CheckIcon size={14} className="text-kumo-success" />
      ) : (
        <CopyIcon size={14} />
      )}
    </button>
  );
}
